import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Button, Tabs, Icon, Spin, Tooltip, Divider } from 'antd';
import classNames from 'classnames'
import './job.css'
import { Redirect, Link } from 'react-router-dom'
import axios from 'axios'
import { Odata_Url, Constants } from '../../../../../Constants/Constants'

const TabPane = Tabs.TabPane;
var initialjob = [];
var previous_initialjob = [];

const GroupBy = (data, property) => {
    return data.reduce((acc, obj) => {
        const key = obj[property]
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})
}

class Job extends Component {
    constructor() {
        super();
        this.state = {
            jobtype: [],
            select_job: [],
            initial_job: [],
            status_factory: false,
            status_office: false,
            selected_category: null,
            loading: false,
            width: window.innerWidth,
            height: window.innerHeight
        }
        this.clear = this.clear.bind(this)
        this.save_job = this.save_job.bind(this)
        this.onclose = this.onclose.bind(this)
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions = () => {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight
        })
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentWillMount() {

        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })

        // console.log(se_job)
        if (this.props.selected_category === "factory") {
            this.setState({
                status_office: true,
            })
        }
        if (this.props.selected_category === "office") {
            this.setState({
                status_factory: true,
            })
        }

        this.setState({
            selected_category: this.props.selected_category
        })

        this.getJobType().then(job => {
            var se_job = JSON.parse(window.localStorage.getItem('select_job'))
            this.setState({ jobtype: job })
            if (se_job !== null) {
                initialjob = se_job
            } else {
                job.map((l, i) => { initialjob[i] = { factory: 0, office: 0 } })
            }
            previous_initialjob = initialjob
            let groupKey = (job.find(x => (initialjob[x.index] || {}).factory === 1) || {}).GroupName || ''
            let groupKeyOffice = (job.find(x => (initialjob[x.index] || {}).factory === 1) || {}).GroupName || ''
            this.setState({
                initial_job: initialjob,
                groupKey: groupKey,
                groupKeyOffice: groupKeyOffice
            })
        })
    }

    async getJobType() {
        this.setState({ loading: true })
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let job_res = await axios.get(
                    Odata_Url + 'OJobType?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                    response.data.value.forEach(function (element, i) {
                        element.index = i
                        data.push(element);
                    });
                    window.localStorage.setItem('Jobtype', JSON.stringify(data));
                    return data;
                }, (error) => {
                    console.log(error);
                });
                return job_res;
            }, (error) => {
                console.log(error);
                if (401 === error.response.status) {
                    window.location.href = "auth";
                }
            });
        this.setState({ loading: false })
        return res;
    }

    select_job_office(id) {
        if (initialjob[id].office === 0) {
            for (var i = 0; i < initialjob.length; i++) {
                initialjob[i].office = 0
            }
            initialjob[id].office = 1

        } else {
            initialjob[id].office = 0
        }

        this.setState({
            initial_job: initialjob
        })

        var status_select_job = false
        var num_select = 0
        for (var i = 0; i < initialjob.length; i++) {
            if (initialjob[i].factory === 1) {
                status_select_job = true;
                num_select++
                break;
            }
            if (initialjob[i].office === 1) {
                num_select++
                break;
            }
        }
        if (num_select !== 0) {
            if (status_select_job) {
                this.setState({
                    status_office: true,
                    selected_category: "factory"
                })
            } else {
                this.setState({
                    status_factory: true,
                    selected_category: "office"
                })
            }
        } else {
            this.setState({
                status_factory: false,
                status_office: false,
                selected_category: ""
            })
        }
    }

    select_job_factory(id) {
        if (initialjob[id].factory === 0) {
            for (var i = 0; i < initialjob.length; i++) {
                initialjob[i].factory = 0
            }
            initialjob[id].factory = 1
        } else {
            initialjob[id].factory = 0
        }


        this.setState({
            initial_job: initialjob
        })

        var status_select_job = false
        var num_select = 0
        for (var i = 0; i < initialjob.length; i++) {
            if (initialjob[i].factory === 1) {
                status_select_job = true;
                num_select++
                break;
            }
            if (initialjob[i].office === 1) {
                num_select++
                break;
            }
        }
        if (num_select !== 0) {
            if (status_select_job) {
                this.setState({
                    status_office: true,
                    selected_category: "factory"
                })
            } else {
                this.setState({
                    status_factory: true,
                    selected_category: "office"
                })
            }
        } else {
            this.setState({
                status_factory: false,
                status_office: false,
                selected_category: ""
            })
        }
    }
    save_job() {
        window.localStorage.setItem('select_job', JSON.stringify(initialjob))
        window.localStorage.removeItem("type_of_category")
        window.localStorage.removeItem("Select_Category")
        window.localStorage.removeItem("Detail_Category")
        this.props.SET_SELECTED_CATEGORY(this.state.selected_category)
        this.props.selectjob(initialjob, this.state.selected_category)
        this.props.onclose()
    }
    clear() {
        for (var i = 0; i < initialjob.length; i++) {
            initialjob[i].factory = 0
            initialjob[i].office = 0
        }
        this.setState({
            initial_job: initialjob,
            status_factory: false,
            status_office: false,
            selected_category: ""
        })
        window.localStorage.removeItem("select_job")
        window.localStorage.removeItem("type_of_category")
        window.localStorage.removeItem("Select_Category")
        window.localStorage.removeItem("Detail_Category")
    }
    onclose() {
        this.setState({
            initial_job: previous_initialjob
        })
        this.props.onclose()
    }
    render() {
        const { initial_job, isEng } = this.state
        let factory = this.state.jobtype.filter(x => x.Type === "factory")
        let office = this.state.jobtype.filter(x => x.Type === "office")
        let group = GroupBy(factory, isEng ? 'GroupName_EN' : 'GroupName')
        let office_group = GroupBy(office, isEng ? 'GroupName_EN' : 'GroupName')
        return (
            <div style={{ width: "100%" }}>
                <Spin spinning={this.state.loading} size="large" style={{ top: "50%" }} tip="Loading...">

                    <div className="job-title" >
                        Please select job type
                    </div>
                    <Icon type="close" style={{ position: "absolute", right: "13px", top: "15px", cursor: "pointer" }} onClick={this.props.onclose} />
                    <Tabs style={{ marginLeft: "2px", marginRight: "2px" }} defaultActiveKey={this.state.status_factory ? "2" : "1"}>
                        <TabPane tab={<span><Icon type="setting" />Factory&nbsp;</span>} key="1" tabBarStyle={{ width: "50%" }} disabled={this.state.status_factory} >
                            <div style={{ textAlign: "center", fontSize: "smaller", margin: '10px 0px 10px 0px' }}>
                                <Tabs activeKey={this.state.groupKey || (factory[0] || {}).GroupName} type='card' size='small' tabPosition='left' onChange={e => { this.setState({ groupKey: e, groupKeyOffice: '' }) }}>
                                    {
                                        Object.keys(group).map(l => {
                                            return (
                                                <TabPane tab={this.state.width > 600 ? l : <small title={l} >{l.length < 8 ? l : l.substr(0, 8) + '..'}</small>} key={l}>
                                                    <Divider><span>{l}</span></Divider>
                                                    <div style={{ textAlign: 'center' }}>
                                                        {
                                                            group[l].map(g => {
                                                                return (
                                                                    <div className="div-image-job"
                                                                        style={{ display: "inline-block" }}
                                                                        key={"job" + g.PKJobTypeID}
                                                                        title={this.state.isEng ? g.Short_detail_EN : g.Short_detail}
                                                                    >
                                                                        <div id={'pop' + g.index} className={classNames({
                                                                            'job-body-icon-selected': initial_job.length > 0 && 1 === initial_job[g.index].factory,
                                                                            'job-body-icon-not-select': initial_job.length == 0 || 0 === initial_job[g.index].factory
                                                                        })} style={{ maxWidth: "52px", maxHeight: "52px", border: "1px solid #BFBFBF", display: "inline-block", padding: "7px", borderRadius: "5%", marginRight: "5px", marginTop: "5px", cursor: "pointer" }}>
                                                                            <img src={"/images/" + g.Image_name} onClick={() => this.select_job_factory(g.index)} style={{ width: "90%", filter: "grayscale(100%)", position: "relative" }} />
                                                                        </div>
                                                                        <div style={{ textAlign: 'center', color: "#000", overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                                            <small>{this.state.isEng ? g.Short_detail_EN : g.Short_detail}</small>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </TabPane>
                                            )
                                        })
                                    }
                                </Tabs>
                            </div>
                        </TabPane>
                        <TabPane tab={<span><Icon type="home" />Office</span>} key="2" tabBarStyle={{ width: "50%" }} disabled={this.state.status_office}>
                            <div style={{ textAlign: "center", fontSize: "smaller" }}>
                                <Tabs activeKey={this.state.groupKeyOffice} tabPosition='left' size='small' onChange={e => { this.setState({ groupKeyOffice: e, groupKey: '' }) }}>
                                    {
                                        Object.keys(office_group).map(l => {
                                            return (
                                                <TabPane tab={this.state.width > 600 ? l : <small title={l} >{l.length < 8 ? l : l.substr(0, 8) + '..'}</small>} key={l}>
                                                    <Divider><span>{l}</span></Divider>
                                                    {
                                                        office_group[l].map(g => {
                                                            return (
                                                                <div className="div-image-job"
                                                                    style={{ display: "inline-block" }}
                                                                    key={"job" + g.PKJobTypeID}
                                                                    title={this.state.isEng ? g.Short_detail_EN : g.Short_detail}
                                                                >
                                                                    <div id={'pop' + g.index} className={classNames({
                                                                        'job-body-icon-selected': initial_job.length > 0 && 1 === initial_job[g.index].office,
                                                                        'job-body-icon-not-select': initial_job.length == 0 || 0 === initial_job[g.index].office
                                                                    })} style={{ maxWidth: "52px", maxHeight: "52px", border: "1px solid #BFBFBF", display: "inline-block", padding: "7px", borderRadius: "5%", marginRight: "5px", marginTop: "5px", cursor: "pointer" }}>
                                                                        <img src={"/images/" + g.Image_name} onClick={() => this.select_job_office(g.index)} style={{ width: "90%", filter: "grayscale(100%)", position: "relative" }} />
                                                                    </div>
                                                                    <div style={{ textAlign: "center", color: "#000", overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                                        {this.state.isEng ? g.Short_detail_EN : g.Short_detail}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </TabPane>
                                            )
                                        })
                                    }
                                </Tabs>
                            </div>
                        </TabPane>
                    </Tabs>

                    <div style={{ width: "100%", marginTop: "10px" }}>
                        <Button onClick={this.clear} style={{ width: "30%", height: "48px", fontSize: "18px", borderRadius: "10px", outline: "none", backgroundColor: "rgb(0,152,139)", color: "white" }}>
                            Clear
                    </Button>
                        <Button onClick={this.save_job} style={{ width: "30%", height: "48px", fontSize: "18px", float: "right", borderRadius: "10px", backgroundColor: "rgb(0,152,139)", color: "white" }}>
                            Save
                    </Button>
                    </div>
                </Spin>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        SET_SELECTED_CATEGORY: (value) => {
            dispatch({
                type: "SET_IMAGE_CATEGORY",
                selected_category: value
            })
        },
    }
}

const Newobservation_Checklist_Job = Form.create()(Job);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Checklist_Job)